import { Dispatch, useCallback, useState } from 'react';

import { PackingAction } from '../state/packingListReducer';

export const useDiscardGuard = (dispatch: Dispatch<PackingAction>, onClose: () => void) => {
  const [hasChanges, setHasChanges] = useState(false);
  const [showDiscardConfirm, setShowDiscardConfirm] = useState(false);
  const dispatchAndMark = useCallback(
    (action: PackingAction) => {
      setHasChanges(true);
      dispatch(action);
    },
    [dispatch],
  );
  const requestClose = useCallback(() => {
    if (hasChanges) {
      setShowDiscardConfirm(true);
      return;
    }
    onClose();
  }, [hasChanges, onClose]);
  const confirmDiscard = useCallback(() => {
    setShowDiscardConfirm(false);
    onClose();
  }, [onClose]);
  const cancelDiscard = useCallback(() => {
    setShowDiscardConfirm(false);
  }, []);

  return { dispatchAndMark, requestClose, showDiscardConfirm, confirmDiscard, cancelDiscard };
};
